import { render, staticRenderFns } from "./ModuleWrapper.vue?vue&type=template&id=6cf5e154&"
import script from "./ModuleWrapper.vue?vue&type=script&lang=ts&"
export * from "./ModuleWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports